import {
  POLICY_FETCHING,
  POLICY_FAILED,
  POLICY_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case POLICY_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case POLICY_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case POLICY_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
